import { defineLegacyDefaultTheme } from './defineLegacyDefaultTheme';

/** A true graphite monochrome with a whisper of cool accent hue. */
export const voidTheme = defineLegacyDefaultTheme({
  id: 'Void',
  tokens: {
    a0: { l: 0.8, c: 0.03, h: 250 },
    a1: { l: 0.8, c: 0.03, h: 290 },
    a2: { l: 0.8, c: 0.03, h: 330 },
    a3: { l: 0.8, c: 0.03, h: 10 },
    a4: { l: 0.8, c: 0.03, h: 50 },
    b0: { l: 0.15, c: 0, h: 0 },
    b1: { l: 0.19, c: 0, h: 0 },
    b2: { l: 0.22, c: 0, h: 0 },
    b3: { l: 0.25, c: 0, h: 0 },
    b4: { l: 0.29, c: 0, h: 0 },
    c0: { l: 0.95, c: 0, h: 0 },
    c1: { l: 0.82, c: 0, h: 0 },
    c2: { l: 0.72, c: 0, h: 0 },
    c3: { l: 0.63, c: 0, h: 0 },
    c4: { l: 0.55, c: 0, h: 0 },
  },
});
